import Icon from '../components/Icon.vue'

Icon.register({
  'user-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0 252.9 0 198.5 51.8 193.1 117.4L45.5 3.4C38.5-2 28.5-0.8 23 6.2L3.4 31.4C-2 38.4-0.8 48.4 6.2 53.8L594.6 508.5C601.6 513.9 611.6 512.7 617.1 505.7L636.7 480.4C642.1 473.6 640.8 463.5 633.8 458.1zM96 422.4V464C96 490.5 117.5 512 144 512H494.2L207.4 290.3C144.2 301.3 96 356 96 422.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-slash.js
// module id = dA13
// module chunks = 144